/**
 * External Dependencies
 */
 import 'jquery';

 // import local dependencies
 import Router from './util/Router';
 import common from './routes/common';
 import blog from './routes/blog';
 import navigation from './modules/navigation';
 
 /** Populate Router instance with DOM routes */
 const routes = new Router({
   // All pages
   common,
   blog,
 });
 
 window.onload = () => {
   routes.loadEvents();
 }

 /**
  * The menu is wired up straight away rather than on `window.onload` with
  * everything else: `load` waits for every image and font, which on this site
  * is several seconds after the bundle is already in the page, and until then
  * clicking the menu did nothing. This bundle is enqueued at the end of the
  * body, so the header is already in the DOM.
  *
  * Registered after the `onload` handler above on purpose: should this throw,
  * the rest of the theme still gets its chance to run.
  */
 navigation();